package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.SignSymptomCategory
import com.jingfangpai.common.orm.mapping.enums.SignSymptomType
import com.jingfangpai.common.orm.mapping.enums.SignSymptomName
import com.jingfangpai.common.orm.mapping.enums.SignSymptomApplicable
import kotlin.collections.Set
import com.jingfangpai.common.orm.mapping.enums.SignSymptomStatus
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer
import com.jingfangpai.common.orm.mapping.enums.SignSymptomOwerType

@Serializable
open class SignSymptom(var id: String? = null){
	var category: SignSymptomCategory? = null
	var type: SignSymptomType? = null
	var name: SignSymptomName? = null
	var alias: String? = null
	var nameAbbr: String? = null
	var description: String? = null
	var belongToId: String? = null
	var applicable: Set<SignSymptomApplicable>? = null
	var status: SignSymptomStatus? = null
	var createdBy: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null
	@Serializable(with = DateTimeSerializer::class)
	var timestamp: DateTime? = null
	var weight: Int? = null
	var aliasSetId: String? = null
	var owerType: SignSymptomOwerType? = null
	var ownerId: String? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as SignSymptom
		if (id != other.id) return false
		if (category != other.category) return false
		if (type != other.type) return false
		if (name != other.name) return false
		if (alias != other.alias) return false
		if (nameAbbr != other.nameAbbr) return false
		if (description != other.description) return false
		if (belongToId != other.belongToId) return false
		if (applicable != other.applicable) return false
		if (status != other.status) return false
		if (createdBy != other.createdBy) return false
		if (createdOn != other.createdOn) return false
		if (timestamp != other.timestamp) return false
		if (weight != other.weight) return false
		if (aliasSetId != other.aliasSetId) return false
		if (owerType != other.owerType) return false
		if (ownerId != other.ownerId) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (category?.hashCode() ?: 0)
		result = 31 * result + (type?.hashCode() ?: 0)
		result = 31 * result + (name?.hashCode() ?: 0)
		result = 31 * result + (alias?.hashCode() ?: 0)
		result = 31 * result + (nameAbbr?.hashCode() ?: 0)
		result = 31 * result + (description?.hashCode() ?: 0)
		result = 31 * result + (belongToId?.hashCode() ?: 0)
		result = 31 * result + (applicable?.hashCode() ?: 0)
		result = 31 * result + (status?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		result = 31 * result + (timestamp?.hashCode() ?: 0)
		result = 31 * result + (weight?.hashCode() ?: 0)
		result = 31 * result + (aliasSetId?.hashCode() ?: 0)
		result = 31 * result + (owerType?.hashCode() ?: 0)
		result = 31 * result + (ownerId?.hashCode() ?: 0)
		return result
	}

}
